/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Copilot_Disable_TitleInputs */



/**
* | output |
* | --- |
* | "Disable copilot?" |
*
* @param {Partner_Manage_Copilot_Disable_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_disable_title = /** @type {((inputs?: Partner_Manage_Copilot_Disable_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_Disable_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Copilot deaktivieren?")
	return /** @type {LocalizedString} */ ("Disable copilot?")
});